<svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 6L6.16261 1.06621C6.14221 1.04539 6.11715 1.02873 6.08908 1.01732C6.06101 1.0059 6.03057 1 5.99978 1C5.969 1 5.93856 1.0059 5.91049 1.01732C5.88242 1.02873 5.85736 1.04539 5.83696 1.06621L1 6" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
